module.exports = __webpack_public_path__ + "img/04.9dbe2c6c.png";